import { useEffect, useState } from 'react';
import { AUTH_CHANGED_EVENT } from '../services/authEvents';
import { displayName } from '../services/authSync';
import { t } from '../i18n';

// Banner shown when another tab of this browser signs in as someone else or
// signs out (R0). All tabs share one session, so this tab now uses it too.
export default function AuthSyncNotice() {
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    const onChange = (e) => {
      const { kind, user, previous, fromOtherTab } = e.detail || {};
      if (kind === 'switched') {
        setNotice(t('authSync.switched', { name: displayName(user) }));
      } else if (kind === 'login') {
        setNotice(null); // this tab's own login
      } else if (kind === 'logout' && fromOtherTab && previous) {
        setNotice(t('authSync.signedOut'));
      }
    };
    window.addEventListener(AUTH_CHANGED_EVENT, onChange);
    return () => window.removeEventListener(AUTH_CHANGED_EVENT, onChange);
  }, []);

  if (!notice) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="auth-sync-notice"
      className="fixed left-1/2 top-3 z-[1500] flex w-[min(100vw-2rem,40rem)] -translate-x-1/2 items-center gap-3 rounded-lg bg-slate-900 px-4 py-3 text-sm font-medium text-white shadow-lg"
    >
      <p className="min-w-0 flex-1 leading-snug">{notice}</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="shrink-0 rounded-md bg-white/15 px-2 py-1 text-xs font-semibold hover:bg-white/25"
      >
        {t('authSync.reload')}
      </button>
      <button
        type="button"
        onClick={() => setNotice(null)}
        aria-label={t('common.dismissShort')}
        className="shrink-0 rounded-md px-2 py-1 text-lg leading-none hover:bg-white/15"
      >
        ×
      </button>
    </div>
  );
}
